import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { LoadingOutlined, InfoCircleOutlined, UploadOutlined, DownOutlined, AppstoreAddOutlined, PlusOutlined, DeleteOutlined, ArrowLeftOutlined, RetweetOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import { Spin, Breadcrumb, Button, Popover, Dropdown, Space, Input, Menu, Layout, Row, Col, Form, message, Upload, Tooltip } from "antd";
import CustomerMainLayout from "../CustomerComponents/CustomerMainLayout";
import ActivityAndExploreSection from "./ActivityAndExploreSection";
import ProductSelectionModal from "./ProductSelectionModal"
import { THUMBNAIL_URL, WALMART_COMPANY_ID } from "../../../environments/env";
import ENVIRONMENT from "../../../environments";
import * as Utilities from '../../App/Utilities';

import axios from "axios";
import AIGridOverlay from "./AIGridOverlay";
import "./index.scss";

import * as Constants from "../CustomerComponents/Constants";
import TwoDImagesModal from "../CustomerComponents/TwoDImagesPage/TwoDImagesModal";
import { dummyAIgeneratedImages } from "./DummyConstants";

import SubscriptionUpgradeManager from "../CustomerComponents/SubscriptionUpgradeManager/SubscriptionUpgradeManager";

const { Content } = Layout;
const {Dragger} = Upload

let CUSTOMER_USERNAME = localStorage.getItem("username");
let COMPANY_ID = localStorage.getItem('company_id')

const AssetCreateOptions = (props) => {
  const [modelLoader, setModelLoader] = useState(false)
  const [draggerOpened, setDraggerOpened] = useState(false)
  const [modelGenerationLoader, setModelGenerationLoader] = useState(false)
  const [filesList, setFilesList] = useState([])
  const [selectedUnit, setSelectedUnit] = useState("inches");
  const draggerRef = useRef(null)
  const buttonRef = useRef(null);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [openProductModal, setOpenProductModal] = useState(false);


  const menu = (
    <Menu>
      <Menu.Item onClick={() => setSelectedUnit("inches")}>Inches</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("meters")}>Meters</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("centimeters")}>Centimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("millimeters")}>Millimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("feet")}>Feet</Menu.Item>
    </Menu>
  );


  const validateFile = (file) => {
    const isAllowedFormat = [
      "image/png",
      "image/jpeg",
      "image/webp",
      "image/heic",
      "image/tiff"
    ].includes(file.type);

    if (!isAllowedFormat) {
      message.error("Only .png, .jpg, .webp, .heic, and .tiff formats are allowed.");
      return false;
    }

    return true;
  };

  const uploadProps = {
    ...Constants.upload_props,
    multiple: true,
    accept: ".jpg,.jpeg,.png,.tiff,.webp,.heic",
    beforeUpload: (file) => {
      return validateFile(file)
    },
    fileList: filesList,
    onChange(info) {
      // Merge the new files with the existing list, avoiding duplicates by UID
      setFilesList((prevList) => {
        const mergedList = [...prevList, ...info.fileList];
        return [...new Map(mergedList.map(file => [file.uid, file])).values()];
      });

      const { status } = info.file;
      console.log(info);
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        if(info.file.error.code.includes('Credentials')){
          message.error('Your session has expired. Please reload the page.')
        }
        else{
          message.error(`${info.file.name} file upload failed.`);
        }
      }

      props.setStage('upload_images')
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dragger
    if (draggerRef.current && !draggerRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      setDraggerOpened(false); // Update state when clicking outside
    }
  };


  const handleProductAddOption = () => {
    // Check if the click is outside the dragger
    // if (uploadButtonRef.current && !uploadButtonRef.current.contains(event.target)) {
      setOpenProductModal(true); // Update state when clicking outside
    // }
  };

  const handleFormSubmit = () => {
    let isFormValid = true
    let errorMessage = ""

    if(filesList.length == 0){
      isFormValid = false
      errorMessage = "Upload product images to proceed."
    }
    else{
      filesList.map((item) => {
        if(item.status === "uploading"){
          isFormValid = false
          errorMessage = "Please wait for the upload(s) to complete"
        }
        else if(item.status === "error"){
          isFormValid = false
          if(item.error.code.includes('Credentials')){
            errorMessage = 'Your session has expired. Please reload the page.'
          }
          else{
            errorMessage = `${item.name} file upload failed.`
          }
        }
      })
    }
      
    const values = form.getFieldsValue()
    const {height, depth, width} = values

    if(height < 0 || width < 0 || depth < 0){
      isFormValid = false;
      errorMessage = "Product dimensions needs to be positive"
    }
    if(!isFormValid && errorMessage){
      message.error(errorMessage)
    }
    
    if (formRef.current && isFormValid) {
      formRef.current.submit(); // submit form to create product and call asset generation helper lambda
    }
  }


  const generateFilesUrls = () => {
    let urls = []
    for(const obj of filesList){
      urls.push(ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent('test_files/' + obj.uid + '/' + obj.name))
    }
    return urls
  }

  const generateAiAssets = (values) => {
    if (props.requestStatus == "allowed" || props.requestStatus == "always_allowed") {
      performGenerateAiAssets(values)
    }
    else {
      props.setSubscriptionUpgradeManagerModel(true);
    }
  
  }
  
  const performGenerateAiAssets = (values) => {
    let dimensionMultiplier = 1;
    if (selectedUnit == "meters") {
      dimensionMultiplier = 39.3701;
    } else if (selectedUnit == "centimeters") {
      dimensionMultiplier = 0.393701;
    } else if (selectedUnit === "millimeters") {
      dimensionMultiplier = 0.0393701; // 1 mm = 0.0393701 inches
    } else if (selectedUnit === "feet") {
      dimensionMultiplier = 12; // 1 foot = 12 inches
    }

    let payload = {
      product_name: values.product_name,
      brand_id: "",
      product_model_type: "product",
      dimensions: "inches",
      height: parseFloat(values.height) * dimensionMultiplier,
      width: parseFloat(values.width) * dimensionMultiplier,
      length: parseFloat(values.depth) * dimensionMultiplier,
      materials: [],
      model_status: 13,
      group_id: "",
      components: [],
      user_type: "customer",
      pantone_color: "",
      hex_color: "",
      is_configurable: false,
      need_to_model: "low_res",
      modeling_required: true,
      uploaded_model: false,
      designed_product: true,
      licensing_options: {"license": "private"},
      segmented: false,
      user_usecase: ["low_res"],
      company_id: COMPANY_ID,
      username: CUSTOMER_USERNAME,
      is_ai_model: true,
      product_photos: filesList,
      model_info: {
        height: parseFloat(values.height) * dimensionMultiplier,
        width: parseFloat(values.width) * dimensionMultiplier,
        depth: parseFloat(values.depth) * dimensionMultiplier,
      }
    }
    setModelGenerationLoader(true)
    
    // track ai flow analytics
    let aiFlowAnalyticsPayload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': 'AI Model Creation',
      'action': 'AI Model Creation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent,
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, aiFlowAnalyticsPayload)


    let metadata_extract_payload = {
      "urls": generateFilesUrls(),
      // "pid": productId  //this is to be added on the back-end
    }

    let helperPayload = {
      "action": "trigger_model_generation_job", 
      "image_urls": generateFilesUrls(), 
      // "product_id": productId,   //this is to be added on the back-end
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "username": CUSTOMER_USERNAME,
      "company_id": COMPANY_ID || null
    }

    let lifestyleGenerationPayload = {
      "action": "trigger_lifestyle_generation_job",
      // "product_id": productId,  //this is to be added on the back-end
      "username": CUSTOMER_USERNAME,
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "prompt": "generate an aesthetic product background",
      "image_urls": generateFilesUrls(), 
      "company_id": COMPANY_ID || null
    }

    let aiGenerateAssetsPayload = {
      'model_create_payload': payload,
      'metadata_extract_payload': metadata_extract_payload,
      'model_generation_job_payload': helperPayload,
      'lifestyle_generation_job_payload': lifestyleGenerationPayload,
      '3d_model': true
    }

    console.log(JSON.stringify(aiGenerateAssetsPayload))

    let gateway_payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "perform",
      "request_payload": aiGenerateAssetsPayload,
      "category": "",
      "request_id": Date.now().toString()
  }  

    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload)
        .then(res => {
            if (res.data.status!=undefined && res.data.status == 1) {
              setModelGenerationLoader(false)
              let productId = res.data.action_response['product_id']
              window.location.pathname = "/products/" + productId
            }
            else{
                message.error('something went wrong');
            }
        });

    return
  }

  useEffect(() => {
    // Add event listener to detect clicks outside
    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("click", handleProductAddOption);

    return () => {
      // Cleanup event listener
      document.removeEventListener("click", handleClickOutside);
      // document.removeEventListener("click", handleProductAddOption);
    };
  }, []);

  useEffect(() => {
    // track ai flow analytics
    let payload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': props.stage == 'options' ? 'AI Creator Page' : props.stage == 'upload_images' ? 'AI Model Creation' : 'Lifestyle Generation',
      'action': 'Navigation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, payload)

  }, [props.stage])

  return (
    <Content className="ai-background-container" style={{height: '100vh', justifyContent: 'flex-start'}}>
      <Row style={{padding: '0px 30px'}}>
        <ProductSelectionModal selectedProductId={props.productId} 
        setSelectedProductId={props.setProductId} setSelectedProductPlatform={props.setSelectedProductPlatform}
        visible={openProductModal} setStage={props.setStage}
        setOpenProductModal={setOpenProductModal} setAiModel={props.setAiModel}/>

        <Col span={24} style={{color: 'black'}}>
            <div className="mt-40 justify-in-center">
              <div className="manrope f-24 lh-32 w-700 black-085" style={{textAlign: 'center', marginBottom: 36}}>Generate a 3D model in minutes</div>
            </div>
            <div className="pb-100 ai-model-generate-form-container">
              <div>
                <span className="manrope f-16 w-700 lh-24 black-085">
                  Add a Product Photo
                </span>
                <div className="file-list-container mt-10">
                  {filesList.map((file) => (
                    <div
                      key={file.uid}
                      className="ai-uploaded-file-card"
                    >
                      {file.status === "uploading" ? (
                        <div className="loader">
                          <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                        </div>
                      ) : (
                        <>
                          <div className="image-wrapper">
                            <img
                              className="ai-file-card-image"
                              src={ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent("test_files" + "/" + file.uid + "/" + file.name)}
                              alt={file.name}
                            />
                          </div>
                          <Button
                            shape="circle"
                            onClick={() => {
                              setFilesList((prevList) => prevList.filter(item => item.uid !== file.uid))
                              }
                            }
                            icon={<DeleteOutlined style={{ color: 'red' }} />}
                            className="ai-img-delete-button"
                          />
                        </>
                      )}
                    </div>
                  ))}
                  {filesList.length == 0
                  ? <div className="dragger-container pos-unset">
                  <Dragger
                      accept=".jpg,.jpeg,.png,.tiff"
                      className="upload-height-170"
                      {...uploadProps}
                      style={{
                        border: "1px dashed #595959",
                        background: "white",
                        borderRadius: 8,
                        padding: 16,
                        textAlign: "center",
                        
                      }}
                    >
                      <div className="manrope">  
                        <div className="manrope f-14 w-500 lh-22 black-085" >Drag & Drop or</div>
                        <span className="mt-10 manrope f-14 w-500 lh-22 black-085"  style={{border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "8px 10px", color: "black"}}><UploadOutlined style={{marginRight: 4}} /> Upload photo</span>
                        <div className="mt-10 manrope f-12 w-400 lh-20" style={{ color: "#595959" }}>
                        Products on clean backgrounds preferred.
                        <div>
                        Supported formats: JPG, PNG, or TIFF
                        </div>
                        </div>
                      </div>
                    </Dragger>
                </div> :  <div>
                    <Dragger className="dragger-height-132 manrope" {...uploadProps}  showUploadList={false} style={{height: 132, width: 132, border: "1px dashed #595959", borderRadius: 8, background: "white"}}>
                      <div className="manrope f-14 w-500 lh-22 black-085">Drag & Drop or </div>
                      <span className="button-inside-upload mt-10" style={{border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "4px 10px", color: "black"}}>+ Add</span>
                    </Dragger>
                  </div>}
                </div>

                <Form form={form} ref={formRef} onFinish={generateAiAssets} layout="vertical" style={{color: 'black'}}>
                  {/* Name Section */}
                  <div>
                    <span className="manrope f-16 w-700 lh-24 black-085 d-block mt-24">Product Name</span>
                    <Form.Item name="product_name" style={{ marginTop: 8 }} rules={[{ required: true, message: "Please enter a product name" }]}>
                      <Input placeholder="Enter product name" className="dimnesion-item-input h-50" />
                    </Form.Item>
                  </div>

                  {/* Dimensions Section */}
                  <div>
                    <span className="manrope f-16 w-700 lh-24 black-085 d-block mt-24">Product Dimensions</span>
                    <div className="mb-8" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span className="manrope f-12 lh-20 w-400 black-085">Enter your best guess if you are not sure.</span>
                      <Dropdown overlay={menu} trigger={["click"]}>
                        <a onClick={(e) => e.preventDefault()}>
                          <Space className="manrope f-14 w-500 lh-22 blue">
                            {selectedUnit}
                            <DownOutlined />
                          </Space>
                        </a>
                      </Dropdown>
                    </div>
                  </div>

                  {/* Dimension Inputs */}
                  <div className="dimnesion-item width-full" style={{ display: "flex", gap: "10px" }}>
                    <Form.Item name="width" style={{ flex: 1 }} rules={[{ required: true, message: "Please enter width" }]}>
                      <Input type="number" placeholder="Width" className="dimnesion-item-input h-50" suffix={<span className="manrope f-12 w-400">{selectedUnit}</span>} 
                        min="0"
                        onKeyPress={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}/>
                    </Form.Item>

                    <Form.Item name="height" style={{ flex: 1 }} rules={[{ required: true, message: "Please enter height" }]}>
                      <Input type="number" placeholder="Height" className="dimnesion-item-input h-50" suffix={<span className="manrope f-12 w-400">{selectedUnit}</span>} 
                        min="0"
                        onKeyPress={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}/>
                    </Form.Item>

                    <Form.Item name="depth" style={{ flex: 1 }} rules={[{ required: true, message: "Please enter depth" }]}>
                      <Input type="number" placeholder="Depth" className="dimnesion-item-input h-50" suffix={<span className="manrope f-12 w-400">{selectedUnit}</span>} 
                        min="0"
                        onKeyPress={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}/>
                    </Form.Item>
                  </div>
                </Form>
              </div>

              <div className="justify-space-between mt-24">
                <div>
                  <p className="manrope f-12 w-400 black-00 text-left">Upload tips for best results:</p>
                  <div className="justify-in-start">
                    <Popover
                    placement="bottom" 
                    overlayClassName="tips-popover"  content={
                      <div>
                      <div className="justify-space-between">
                      <img src="/img/ai_creator/clean_bg_1.png" className="mr-8"/>
                      <img src="/img/ai_creator/clean_bg_2.png" />
                    </div>
                    <div className="manrope f-14 w-500 black-00 mt-16" style={{width: 265}}>Take a clear shot of your product with no obstructions.</div>
                  </div>}>
                    <div className="tip-container manrope f-14 w-500 lh-22 blue">
                      Use a clean background <InfoCircleOutlined className="ml-4" />
                    </div>
                    </Popover>
                    <Popover 
                    placement="bottom"
                    overlayClassName="tips-popover" content={
                      <div>
                      <div className="justify-space-between">
                      <img src="/img/ai_creator/img_angle_1.png" className="mr-8"/>
                      <img src="/img/ai_creator/img_angle_2.png" className="mr-8"/>
                      <img src="/img/ai_creator/img_angle_3.png" className="mr-8"/>
                    </div>
                    <div className="manrope f-14 w-500 black-00 mt-16" style={{width: 420}}>Upload at least one required angle, however, multiple angles will provide more detail.</div>
                    </div>}>
                    <div className="tip-container manrope f-14 w-500 lh-22 blue ml-4" >
                      Add multiple angles <InfoCircleOutlined className="ml-6" />
                    </div>
                    </Popover>
                  </div>
                </div>
                <Button disabled={modelGenerationLoader} className="generate-ai-btn font-16" onClick={() => handleFormSubmit()}>
                  <img src="/img/ai_creator/ai-twinkle.svg" className="mr-4" />Generate
                  {modelGenerationLoader && <LoadingOutlined/> }
                </Button>
              </div>

            </div>
          </Col>
        
      </Row>
    </Content>

  )
}

const AiModelCreate = (props) => {  
  const query = new URLSearchParams(props.location.search);
  const stage = query.get("stage") ?? 'upload_images';
  const productId = query.get("productId") ?? "";
  const queryParamImageUri = query.get("img") ?? ""
  const queryParamPrompt = query.get("prompt") ?? ""
  const [aiModel, setAiModel] = useState(query.get("aiModel")?.toLocaleLowerCase() == 'true' ? true : false)
  const [assetGenerationStage, setAssetGenerationStage] = useState(stage);
  const [filesList, setFilesList] = useState([])
  const [isModalVisible, setisModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [imgIndex, setImgIndex] = useState(-1);
  const [deleteModal, setDeleteModal] = useState();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [libraryProductId, setLibraryProductId] = useState(productId);
  const [selectedProductPlatform, setSelectedProductPlatform] = useState('aws')
  const [imagesCount, setImagesCount] = useState({
    all: 0,
    silo: 0,
    lifestyle: 0,
    spin_360: 0,
    mp4: 0,
    favourites: 0,
    ai: 0,
  });
  const [imageType, setImageType] = useState("ai");
  const [yourActivityRenders, setYourActivityRenders] = useState([]);
  const [yourActivityLoading, setYourActivityLoading] = useState(true);
  const [requestStatus, setRequestStatus] = useState('update_subscription');
  const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false)
  const [cardStatus, setCardStatus] = useState(0)

  useEffect(() => {
    loadUserRequestStatus();

    //Add Google Analytics Tags
    if (window.location.hostname !== "app.all3d.ai" && window.location.hostname !== "d1v6a0zmc8r81.cloudfront.net") return; // Load GTM only on production
    const script = document.createElement("script");
    
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PZWBHPCS');`;
    document.head.appendChild(script);
    
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PZWBHPCS"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);


  const loadUserRequestStatus = () => {
    let payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "check",
      "category": ""
    }
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, payload)
        .then(res => {
            console.log(res.data)
            setRequestStatus(res.data['request_allowed']);
            setCardStatus(res.data['card_status'])
        });
  }

  const calculateCount = (array) => {
    // Initialize counts for each category
    const counts = array.reduce(
      (counts, image) => {
        if (image.image_type === "silo") counts.silo++;
        if (image.image_type === "lifestyle") counts.lifestyle++;
        if (image.image_type === "spin_360") counts.spin_360++;
        if (image.image_type === "mp4") counts.mp4++;
        if (image.image_type === "ai") counts.ai++;
        if (image.isFavourite) counts.favourites++; // Count favourites if `isFavourite` is true
        counts.all++; // Increment total count

        return counts;
      },
      {
        all: 0,
        silo: 0,
        lifestyle: 0,
        spin_360: 0,
        mp4: 0,
        favourites: 0,
        ai: 0,
      }
    );

    // Set the state with the final counts
    setImagesCount(counts); // Assuming setImagesCount is already available in the scope
  };

  const handleOk = () => {
    setisModalVisible(false);
  };

  const handleCancel = () => {
    setisModalVisible(false);
  };

  const handleDeleteClick = (image, imgIndex) => {
    setDeleteModal(image);
    if (imgIndex) setImgIndex(imgIndex);
  };

  
  const aiGeneratedImagesPayload = useMemo(
    () => ({
      customer_username: CUSTOMER_USERNAME,
    }),
    [CUSTOMER_USERNAME]
  );
  const {
    data: aiGeneratedImages,
    refetch: aiImagesRefetech,
    isLoading: aiImagesLoading,
  } = useQuery(
    [`${ENVIRONMENT.AI_GENERATED_IMAGES}`, aiGeneratedImagesPayload],
    () => aiGeneratedRenders(aiGeneratedImagesPayload),
    {
      enabled: !!aiGeneratedImagesPayload,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const aiGeneratedRenders = useCallback((payload) => {
    // return axios.post(ENVIRONMENT.AI_GENERATED_IMAGES, payload).then((res) => {
    //   return res.data.map((img) => {
    //     return {
    //       ...img,
    //       image_type: "ai",
    //       is360: img.threesixty_frames !== undefined,
    //       entity_id: img.product_id,
    //       platform: img.platform,
    //       entity_type: "product",
    //       image_name: img.id.toString() + ".jpg",
    //       threesixty_frames: img.threesixty_frames !== undefined ? img.threesixty_frames.data : null,
    //     };
    //   });
    // });
    return dummyAIgeneratedImages
    
  }, []);

  const GetImageURL = (item, thumbnail = false) => {
    if (item.image_type == "silo") {
      if (
        item.image_status == "completed" &&
        (!("is_hidden" in item) || item.is_hidden !== true)
      ) {
        let silo_base_uri = "";
        let unique_attributer = "username";
        if (item.company_id) {
          silo_base_uri = "company/" + item.company_id;
          unique_attributer = "company";
        } else {
          silo_base_uri = item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL(item["platform"]) +
          (thumbnail
            ? ENVIRONMENT.LOW_RES_QA_IMG_URI
            : ENVIRONMENT.QA_IMG_URI) +
          item["entity_id"] +
          "/" +
          silo_base_uri +
          "/" +
          item.camera_name +
          (thumbnail ? "_512" : "") +
          "." +
          item.image_format.replace("tiff", "jpg");
        return imageUrl;
      }
    }

    if (item.image_type === "ai") {
      if (item.is360) {
        let baseUrl = "";
        if (item.company_id) {
          baseUrl = "company/" + item.company_id;
        } else {
          baseUrl = item.captured_by ? item.captured_by : item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL() +
          "product_assets/ai_generated_spin/" +
          `${item.product_id}/frames/` +
          item.uri;
        return imageUrl;
      }
      if(thumbnail){
        return ENVIRONMENT.getBaseURL(item.platform) + item.uri.replace(/(\.[^.]+)$/, "_512$1"); // add _512 before the file format to get low res url link
      }
      return ENVIRONMENT.getBaseURL(item.platform) + item.uri;
    }

    if (item.image_type === "ai_generated_glb") {
      if (thumbnail) {
        return THUMBNAIL_URL + item.product_id + "_default.png" 

      }
      return ENVIRONMENT.getBaseURL(item.platform) + item.uri;
    }

    if (item.image_type == "lifestyle") {
      if (thumbnail) {
        const parts = item.filename.split(".");
        const updatedFilename =
          parts.slice(0, -1).join(".") + "_512." + parts.at(-1);
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          updatedFilename
        ).replace("tiff", "jpg");
      } else {
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          item.filename
        ).replace("tiff", "jpg");
      }
    }

    if (item.image_type == "spin_360") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/threesixtys_frames/" +
        `${baseUrl}/` +
        item.spin_360_frames[0];
      return imageUrl;
    }

    if (item.image_type == "mp4") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/video/" +
        `${baseUrl}/` +
        item.entity_id +
        ".mp4";
      return imageUrl;
    }
  };


  const displayableImages = useMemo(() => {
   
    const concatImg = [
    ]
    let imgs = [];
    if (aiGeneratedImages) {
      imgs = concatImg.concat(aiGeneratedImages).filter(img => img.status === "completed");
    }
    calculateCount(imgs)
    return imgs?.map((image, index) => ({
      ...image,
      orignalIndex: index,
      width: image.width ?? 1024,
      height: image.height ?? 1024,
      src: GetImageURL(image),
      thumbnail: GetImageURL(image, true),
      customOverlay: <AIGridOverlay obj={image} />,
    }))
    
  }, [aiGeneratedImages]);

  const showModal = useCallback((src) => {
    setSelectedImage(
      displayableImages.find((image) => image.src === src)
    );
    setisModalVisible(true);
    let index = displayableImages.findIndex((image) => image.src === src);
    setImgIndex(index);
  }, [displayableImages]); // Only re-create when `displayableImages` changes
  


  const renderDelete = (x) => {
    if (
      !x ||
      (!x.filename && !x.camera_name) ||
      x.image_type === "spin_360" ||
      x.image_type === "mp4"
    )
      return null;

    return (
      <Tooltip title={<span className="manrope f-12 white">Delete</span>}>
        <Button
          onClick={() => handleDeleteClick(x)}
          className="manrope f-14 w-500 lh-22 ai-action-btn ai-action-btn-red"
          icon={<DeleteOutlined />}
        />
      </Tooltip>
    );
  };

  const renderDownload = (src, obj) => {
    return null;

  };


  const renderGenerateHighResImage = (x) => {
    if (!x || !x.filename) return null;
  };


  const renderCollaborationTooltip = (image) => {
    if (
      image.image_type === "spin_360" ||
      image.image_type === "mp4" ||
      image.image_type === "ai"
    ) {
      return null;
    }
  };

  const renderReportButton = (x) => {
    return null
  };

  const renderFavouriteButton = (obj) => {
    if (obj.image_type === "ai") {
      return null;
    }
  }


  return (
    <>
      <CustomerMainLayout selected='30' remove_global_padding={true}>
          <AssetCreateOptions
            displayableImages={displayableImages}
            aiImagesLoading={aiImagesLoading} 
            stage={assetGenerationStage}
            setStage={setAssetGenerationStage}
            activity_images={yourActivityRenders}
            yourActivityLoading={yourActivityLoading}
            showModal={showModal}
            productId={libraryProductId}
            setProductId={setLibraryProductId}
            aiModel={aiModel}
            setAiModel={setAiModel}
            selectedImgUri={queryParamImageUri}
            previousImgPrompt={queryParamPrompt}
            setSelectedProductPlatform={setSelectedProductPlatform}
            selectedProductPlatform={selectedProductPlatform}
            requestStatus={requestStatus}
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
          />
          <TwoDImagesModal
            key={isModalVisible ? "open" : "closed"}
            isVisible={isModalVisible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            currentfile={selectedImage}
            filteredImages={displayableImages}
            renderDelete={renderDelete}
            renderDownload={renderDownload}
            renderGenerateHighResImage={renderGenerateHighResImage}
            setType={setImageType}
            Type={imageType}
            imagesCount={imagesCount}
            renderCollaborationTooltip={renderCollaborationTooltip}
            renderReportButton={renderReportButton}
            renderFavouriteButton={renderFavouriteButton}
            aiPage={true}
          />

          <SubscriptionUpgradeManager
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            cardStatus={cardStatus}
            loadUserRequestStatus={loadUserRequestStatus}
            requestType='ai_model'
          />

      </CustomerMainLayout>
    </>
  );
}

export default AiModelCreate;
